<template>
    <div :class="['bottom-fixed', {'flex':label2}]">
        <div @click="onBtnClick">{{label}}</div>
        <div v-if="label2" @click="onBtn2Click">{{label2}}</div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        label2: {
            type: String,
            default: ''
        }
    },
    data() {
        return {}
    },
    methods: {
        onBtnClick() {
            this.$emit('btnClick')
        },
        onBtn2Click() {
            this.$emit('btn2Click')
        }
    },
}
</script>

<style lang="less" scoped>
.bottom-fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    height: 120px;
    padding: 16px 75px;
    box-sizing: border-box;
    background-color: #fff;
    text-align: center;
    

    div {
        line-height: 88px;
        background-color: var(--epButtonColor);
        color: var(--epTextColor);
        border-radius: 44px;
        font-size: 26px;
    }

    &.flex {
        display: flex;
        justify-content: space-between;

        div {
            width: 280px;
        }
    }
}
</style>